import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

const UNCHANGED = 'unchanged'

const Keys = {
  ADD_CATEGORIES: 'add_categories',
  SET_ALL_AS_UNCHANGED: 'set_all_as_unchanged',
  CLEAR: 'clear'
}

export const state = {
  categories: []
}
export const mutations = {
  [Keys.ADD_CATEGORIES](state, categories) {
    if (!categories || !categories.length) {
      return
    }

    state.categories = categories
  },

  [Keys.SET_ALL_AS_UNCHANGED](state) {
    for (let cat of state.categories) {
      cat.rowState = UNCHANGED
    }
  },

  [Keys.CLEAR](state) {
    state.categories = []
  }
}
export const actions = {
  async refresh({ dispatch, commit, state }, options) {
    options = _.extend({ force: false }, options)

    // clear
    commit(Keys.CLEAR)

    var key = 'data-categories'

    if (options.force !== true) {
      var cached = await dispatch('cache/get', key, { root: true })
      if (cached != null) {
        commit(Keys.ADD_CATEGORIES, cached)
        return
      }
    }

    var result = await post(Endpoints.getUrl('floatingCenterCategory.search'), {})
    if (result.success) {
      var cacheObj = {
        key,
        seconds: 24 * 60 * 60,
        value: result.data.items
      }

      dispatch('cache/set', cacheObj, { root: true })
      commit(Keys.ADD_CATEGORIES, cacheObj.value)
    }
  },

  async modify({ dispatch, commit, state }, categories) {
    // categories = categories.filter(x => x.rowState !== UNCHANGED)

    let result = await post(Endpoints.getUrl('floatingCenterCategory.modify'), { items: categories })
    if (result.success) {
      commit(Keys.SET_ALL_AS_UNCHANGED)
      dispatch('socket/broadcastRefresh', 'Categories', { root: true })
    }
  },

  clear({ commit }) {
    commit(Keys.CLEAR)
  }
}
export const getters = {
  all: state => {
    return state.categories
  },
  allInType: state => type => {
    return state.categories.filter(x => x.type === type)
  },
  getById: state => id => {
    return _.head(state.categories.filter(x => x.id === id))
  },
  derties: state => {
    return state.categories.filter(item => item.rowState !== UNCHANGED)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
